import { useServiceTypeTemplateCtx } from '@/app/(app)/settings/service_types/[id]/provider';
import { Select } from '@/components/atoms/select';
import { ApiSchemas } from '@/components/providers/v1-api';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

const FREQUENCY_UNITS: { value: ApiSchemas['FrequencyUnit']; label: string }[] = [
  { value: 'MANUAL', label: 'Manual' },
  { value: 'DAY', label: 'Days' },
  { value: 'WEEK', label: 'Weeks' },
  { value: 'MONTH', label: 'Months' },
  { value: 'YEAR', label: 'Years' },
];

const ENDING_TYPES: { value: ApiSchemas['EndingType']; label: string }[] = [
  { value: 'NONE', label: 'Never ends' },
  { value: 'NUMBER_OF_OCCURRENCES', label: 'After number of occurrences' },
  { value: 'DATE', label: 'On specific date' },
];

export function ServiceTypeTemplateSchedule() {
  const { serviceTypeTemplate, update } = useServiceTypeTemplateCtx();

  return (
    <div className='flex w-full flex-col gap-8'>
      {/* Frequency Section */}
      <div className='flex flex-col gap-4'>
        <h2 className='text-heading-md'>Service Frequency</h2>
        <div className='grid gap-x-2 gap-y-4 md:grid-cols-2'>
          <div className='space-y-2'>
            <Label>Frequency Type</Label>
            <Select
              options={FREQUENCY_UNITS}
              value={serviceTypeTemplate.frequency_unit}
              onChange={(value) => update({ frequency_unit: value })}
              className='w-full'
            />
          </div>
          {serviceTypeTemplate.frequency_unit !== 'MANUAL' && (
            <div className='space-y-2'>
              <Label>Frequency Value</Label>
              <Input
                type='number'
                min='1'
                value={serviceTypeTemplate.frequency_value || 1}
                onChange={(e) => update({ frequency_value: parseInt(e.target.value) || 1 })}
              />
            </div>
          )}
        </div>
      </div>

      {/* Ending Conditions Section */}
      <div className='flex flex-col gap-4'>
        <h2 className='text-heading-md'>Ending Conditions</h2>
        <div className='grid gap-x-2 gap-y-4 md:grid-cols-2'>
          <div className='space-y-2'>
            <Label>Ending Type</Label>
            <Select
              options={ENDING_TYPES}
              value={serviceTypeTemplate.ending_type}
              onChange={(value) => update({ ending_type: value })}
              className='w-full'
            />
          </div>
          {serviceTypeTemplate.ending_type === 'NUMBER_OF_OCCURRENCES' && (
            <div className='space-y-2'>
              <Label>Number of Occurrences</Label>
              <Input
                type='number'
                min='1'
                value={serviceTypeTemplate.ending_value || 1}
                onChange={(e) => update({ ending_value: parseInt(e.target.value) || 1 })}
              />
            </div>
          )}
        </div>
        {serviceTypeTemplate.ending_type === 'DATE' && (
          <div className='text-sm text-muted-foreground italic'>
            Ending date will have to be set when service is created for customer
          </div>
        )}
      </div>

      {/* Preview Section */}
      <div className='flex flex-col gap-4'>
        <h2 className='text-heading-md'>Schedule Preview</h2>
        <div className='rounded-lg bg-muted/50 p-4'>
          <p className='text-sm text-muted-foreground'>
            {serviceTypeTemplate.frequency_unit === 'MANUAL'
              ? 'This service will need to be scheduled manually.'
              : `This service will repeat every ${serviceTypeTemplate.frequency_value || 1} ${serviceTypeTemplate.frequency_unit.toLowerCase()}.`}{' '}
            {serviceTypeTemplate.ending_type === 'NONE' &&
              serviceTypeTemplate.frequency_unit !== 'MANUAL' &&
              'It will continue indefinitely.'}
            {serviceTypeTemplate.ending_type === 'NUMBER_OF_OCCURRENCES' &&
              `It will end after ${serviceTypeTemplate.ending_value || 1} occurrence${(serviceTypeTemplate.ending_value || 1) > 1 ? 's' : ''}.`}
            {serviceTypeTemplate.ending_type === 'DATE' && 'It will end on the specified date.'}
          </p>
        </div>
      </div>
    </div>
  );
}
